export default __webpack_public_path__ + "static/media/upgrade-report1.333d1ccf.png";